/** Code 39 — génération SVG légère pour étiquettes pharmacie (sans dépendance externe). */

const CODE39: Record<string, string> = {
  "0": "000110100",
  "1": "100100001",
  "2": "001100001",
  "3": "101100000",
  "4": "000110001",
  "5": "100110000",
  "6": "001110000",
  "7": "000100101",
  "8": "100100100",
  "9": "001100100",
  A: "100001001",
  B: "001001001",
  C: "101001000",
  D: "000011001",
  E: "100011000",
  F: "001011000",
  G: "000001101",
  H: "100001100",
  I: "001001100",
  J: "000011100",
  K: "100000011",
  L: "001000011",
  M: "101000010",
  N: "000010011",
  O: "100010010",
  P: "001010010",
  Q: "000000111",
  R: "100000110",
  S: "001000110",
  T: "000010110",
  U: "110000001",
  V: "011000001",
  W: "111000000",
  X: "010010001",
  Y: "110010000",
  Z: "011010000",
  "-": "010000101",
  ".": "110000100",
  " ": "011000100",
  $: "010101000",
  "/": "010100010",
  "+": "010001010",
  "%": "000101010",
  "*": "010010100",
};

const ALLOWED = /^[0-9A-Z\-./+ %$]+$/;

function normalizeCode39(value: string): string {
  return value.trim().toUpperCase().replace(/[^0-9A-Z\-./+ %$]/g, "");
}

export function encodeCode39(value: string): string {
  const normalized = normalizeCode39(value);
  if (!normalized) return "";
  const payload = `*${normalized}*`;
  for (const ch of payload) {
    if (!CODE39[ch]) return normalized.slice(0, 20);
  }
  return payload;
}

export interface BarcodeSvgModel {
  width: number;
  height: number;
  bars: Array<{ x: number; width: number }>;
  humanText: string;
}

export function buildCode39SvgModel(value: string, barWidth = 2, height = 48): BarcodeSvgModel {
  const encoded = encodeCode39(value);
  const narrow = barWidth;
  const wide = barWidth * 3;
  const bars: Array<{ x: number; width: number }> = [];
  let x = 0;
  const gap = barWidth;

  for (const ch of encoded) {
    const pattern = CODE39[ch];
    if (!pattern) continue;
    for (let i = 0; i < pattern.length; i += 1) {
      const isBar = i % 2 === 0;
      const w = pattern[i] === "1" ? wide : narrow;
      if (isBar) {
        bars.push({ x, width: w });
      }
      x += w;
    }
    x += gap;
  }

  return {
    width: Math.max(x, 80),
    height,
    bars,
    humanText: normalizeCode39(value) || value.trim(),
  };
}

export function isCode39Compatible(value: string): boolean {
  const normalized = normalizeCode39(value);
  return normalized.length > 0 && ALLOWED.test(normalized);
}
